import { cn } from '@1trading/react';

import type { Environment } from '@/types/catalog';

export const ENV_DOT_CLASS: Record<Environment, string> = {
  dev: 'bg-emerald-400',
  staging: 'bg-sky-400',
  preprod: 'bg-amber-400',
  production: 'bg-rose-400',
};

export const ENV_LABEL: Record<Environment, string> = {
  dev: 'Dev',
  staging: 'Staging',
  preprod: 'Preprod',
  production: 'Production',
};

export const EnvDot = ({ environment, className }: { environment: Environment; className?: string }) => (
  <span aria-hidden className={cn('size-1.5 rounded-full', ENV_DOT_CLASS[environment], className)} />
);

export const EnvIndicator = ({ environment }: { environment: Environment }) => (
  <span className="flex items-center gap-1.5 text-muted-foreground">
    <EnvDot environment={environment} />
    <span className="font-medium text-[0.625rem] uppercase tracking-wider">{ENV_LABEL[environment]}</span>
  </span>
);
